import { ChatbotMessage } from "@/components/shared/chatbot/useChatbot";
import { JuriSearchFilters } from "@/gql/graphql";

export enum AnalyticEventType {
  LogInSuccess = "[AUTH] LogIn Success",
  LogInFailure = "[AUTH] LogIn Failure",
  LogOutSuccess = "[AUTH] LogOut Success",
  RegisterSuccess = "[AUTH] Register Success",
  RegisterFailure = "[AUTH] Register Failure",
  SearchJurisprudence = "[SEARCH] Buscar Jurisprudencia",
  SearchJurisprudenceError = "[SEARCH] Buscar Jurisprudencia Error",
  AISummary = "[AI] Resumir Principais Resultados",
  AILegalBasis = "[AI] Criar Fundamentação",
  AIError = "[AI] Erro inesperado",
  AiChatTimeout = "[AI] Timeout",
  SearchSuggestionsError = "[SEARCH-SUGGESTIONS] Erro ao gerar sugestões",
  UserFeedback = "Feedback do Usuário",
  FeedbackForm = "Formulário de Feedback",
  UpdateInformation = "[UPDATE-INFORMATION] Atualizar Informações do Usuário",
  UpdateInformationError = "[UPDATE-INFORMATION] Erro ao atualizar informações do usuário",
  ForgotPasswordSuccess = "ForgotPasswordSuccess",
  ForgotPasswordFailure = "ForgotPasswordFailure",
}

export type AnalyticEvent = {
  [key in AnalyticEventType]: AnalyticEventPayload[key];
};

type AnalyticEventPayload = {
  [AnalyticEventType.LogInSuccess]: {};
  [AnalyticEventType.LogInFailure]: { reason?: string };
  [AnalyticEventType.LogOutSuccess]: {};
  [AnalyticEventType.RegisterSuccess]: {};
  [AnalyticEventType.RegisterFailure]: { reason?: string };
  [AnalyticEventType.SearchJurisprudence]: JuriSearchFilters & {
    query: string;
  };
  [AnalyticEventType.SearchJurisprudenceError]: JuriSearchFilters & {
    query: string;
    reason?: string;
  };
  [AnalyticEventType.AISummary]: {
    query?: string;
    chatId: string;
    syllabuses: string[];
    references: { recordId: string; text: string; link?: string }[];
  };
  [AnalyticEventType.AILegalBasis]: {
    query?: string;
    chatId: string;
    syllabus: string;
  };
  [AnalyticEventType.AIError]: {
    query?: string;
    chatId: string;
    reason?: string;
  };
  [AnalyticEventType.SearchSuggestionsError]: {
    query: string;
    reason?: string;
  };
  [AnalyticEventType.AiChatTimeout]: {
    chatId: string;
    streamId: string;
    reason: string;
    content: string;
    lastReceivedAt: Date;
  };
  [AnalyticEventType.UserFeedback]: {
    feedback: string;
    chatbotMessage?: ChatbotMessage;
  };
  [AnalyticEventType.FeedbackForm]: {
    json: any;
  };
  [AnalyticEventType.UpdateInformation]: {
    name: string;
    email: string;
    occupation: string;
    referralSource: string;
    phoneNumber: string;
  };
  [AnalyticEventType.UpdateInformationError]: {
    reason?: string;
    error?: string;
  };
  [AnalyticEventType.ForgotPasswordSuccess]: {};
  [AnalyticEventType.ForgotPasswordFailure]: { error?: any; reason?: string };
};
